import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getBantuan = (params = {}) =>
  axios.get(`${BASE}/bantuan`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      kecamatan: params.kecamatan,
      desaKelurahan: params.desaKelurahan,
      kategori: params.kategori,
      statusrumah: params.statusrumah,
      kategoriStatusRumah: params.kategoriStatusRumah,
      searchName: params.searchName,
      statusProses: params.statusProses,
      JenisBantuan: params.JenisBantuan,
      tahun: params.tahun,
    },
  });

export const getBantuanYears = () =>
  axios.get(`${BASE}/bantuan-years`);

export const getBantuanById = (id) =>
  axios.get(`${BASE}/bantuan/${id}`);

export const getBantuanRekap = () =>
  axios.get(`${BASE}/bantuan-rekap`);

/** Peta eksekutif: penerima bantuan + progres (merah/kuning/hijau) */
export const getBantuanMaps = (params = {}) =>
  axios.get(`${BASE}/maps/bantuan`, {
    params: {
      kecamatan: params.kecamatan || undefined,
      statusProses: params.statusProses || undefined,
    },
  });

export const updateBantuan = (id, payload) =>
  axios.put(`${BASE}/bantuan/${id}`, payload);

export const deleteBantuan = (id) =>
  axios.delete(`${BASE}/bantuan/${id}`);

export const getBantuanGaps = () =>
  axios.get(`${BASE}/bantuan-gaps`);

export const syncBantuanGaps = (payload = {}) =>
  axios.post(`${BASE}/bantuan-sync`, payload);

export const createBantuanManual = (payload) =>
  axios.post(`${BASE}/bantuan-manual`, payload);

export const getTflList = () =>
  axios.get(`${BASE}/tfl-list`);

export const getAgrList = () =>
  axios.get(`${BASE}/agr-list`);

export const assignTflToBantuan = (id, payload) =>
  axios.put(`${BASE}/bantuan/${id}/assign-tfl`, payload);

export const updatePenerimaByTfl = (id, payload) =>
  axios.put(`${BASE}/bantuan/${id}/penerima`, payload);

export const deleteRab = (id) =>
  axios.delete(`${BASE}/rab/${id}`);

export const getRabById = (id) =>
  axios.get(`${BASE}/rab/${id}`);

export const upsertRab = (payload, file) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    if (Array.isArray(v)) { v.forEach(iv => formData.append(k, iv)); return; }
    formData.append(k, v);
  });
  if (file) formData.append('fileRab', file);
  return axios.post(`${BASE}/rab`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getRabByBantuan = (BantuanId) =>
  axios.get(`${BASE}/rab/bantuan/${BantuanId}`);

export const getRabForSupplier = () =>
  axios.get(`${BASE}/rab/supplier`);

export const getAllRab = () =>
  axios.get(`${BASE}/rab/all`);

export const getRabForTfl = () =>
  axios.get(`${BASE}/rab/tfl`);

export const getProgressKeuangan = (RabId) =>
  axios.get(`${BASE}/rab/progress-keuangan/${RabId}`);

export const updateProgressKeuangan = (id, formData) =>
  axios.put(`${BASE}/rab/progress-keuangan/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteProgressDokumen = (id, filename) =>
  axios.delete(`${BASE}/rab/progress-keuangan/${id}/dokumen/${filename}`);

export const deleteProgressFoto = (id) =>
  axios.delete(`${BASE}/rab/progress-keuangan/${id}/foto`);

export const initProgressFisikPembangunan = (RabId) =>
  axios.post(`${BASE}/rab/progress-fisik/${RabId}/pembangunan`);

export const initProgressFisikRehabilitasi = (RabId, payload) =>
  axios.post(`${BASE}/rab/progress-fisik/${RabId}/rehabilitasi`, payload);

export const getProgressFisik = (RabId) =>
  axios.get(`${BASE}/rab/progress-fisik/${RabId}`);

export const updateProgressFisikLangkah = (id, formData) =>
  axios.put(`${BASE}/rab/progress-fisik/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteProgressFisikFoto = (id, filename) =>
  axios.delete(`${BASE}/rab/progress-fisik/${id}/foto/${filename}`);

export const addRehabilitasiLangkah = (RabId, payload) =>
  axios.post(`${BASE}/rab/progress-fisik/${RabId}/rehabilitasi/item`, payload);

export const deleteProgressFisikLangkah = (id) =>
  axios.delete(`${BASE}/rab/progress-fisik/${id}`);

export const initProgressAdministrasi = (RabId) =>
  axios.post(`${BASE}/rab/progress-administrasi/${RabId}`);

export const getProgressAdministrasi = (RabId) =>
  axios.get(`${BASE}/rab/progress-administrasi/${RabId}`);

export const updateProgressAdministrasi = (id, formData) =>
  axios.put(`${BASE}/rab/progress-administrasi/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteProgressAdministrasiDokumen = (id, filename) =>
  axios.delete(`${BASE}/rab/progress-administrasi/${id}/dokumen/${filename}`);

export const deleteProgressAdministrasiFoto = (id, filename) =>
  axios.delete(`${BASE}/rab/progress-administrasi/${id}/foto/${filename}`);

export const upsertAdmBantuan = (formData) =>
  axios.post(`${BASE}/adm-bantuan`, formData);

export const getAdmBantuan = (BantuanId) =>
  axios.get(`${BASE}/adm-bantuan/${BantuanId}`);

export const deleteAdmDokumen = (BantuanId, stage, filename) =>
  axios.delete(`${BASE}/adm-bantuan/${BantuanId}/dokumen/${stage}/${filename}`);

export const deleteAdmFoto = (BantuanId, stage, filename) =>
  axios.delete(`${BASE}/adm-bantuan/${BantuanId}/foto/${stage}/${filename}`);

export const createBantuanLengkap = (payload) =>
  axios.post(`${BASE}/bantuan-lengkap`, payload);

export const createProsesBantuan = (payload) =>
  axios.post(`${BASE}/proses-bantuan`, payload);

export const updateStatusProses = (BantuanId, statusProses) =>
  axios.put(`${BASE}/proses-bantuan/${BantuanId}/status`, { statusProses });

export const getDashboardStats = () =>
  axios.get(`${BASE}/monitoring/dashboard`);

export const getAllMonitoring = (params = {}) =>
  axios.get(`${BASE}/monitoring`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      status: params.status,
      search: params.search,
    },
  });

export const getMonitoringDetail = (BantuanId) =>
  axios.get(`${BASE}/monitoring/${BantuanId}`);

export const addLangkah = (payload) =>
  axios.post(`${BASE}/langkah`, payload);

export const updateLangkahStatus = (id, { status, catatan, foto }) => {
  const formData = new FormData();
  formData.append('status', status);
  if (catatan) formData.append('catatan', catatan);
  if (foto) formData.append('foto', foto);
  return axios.put(`${BASE}/langkah/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateLangkahFormData = (id, formData) =>
  axios.put(`${BASE}/langkah/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const verifikasiLangkah = (id, { status, catatan }) =>
  axios.put(`${BASE}/verifikasi-langkah/${id}`, { status, catatan });

export const getVerifikasiByBantuan = (BantuanId) =>
  axios.get(`${BASE}/verifikasi-langkah/bantuan/${BantuanId}`);

export const deleteLangkah = (id) =>
  axios.delete(`${BASE}/langkah/${id}`);

export const getPresentase = (BantuanId) =>
  axios.get(`${BASE}/presentase/${BantuanId}`);

export const addLog = (formData) =>
  axios.post(`${BASE}/log`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getLogsByBantuan = (BantuanId) =>
  axios.get(`${BASE}/log/${BantuanId}`);

export const addKeluhan = (payload) =>
  axios.post(`${BASE}/keluhan-bantuan`, payload);

export const getKeluhan = (BantuanId) => {
  const url = `${BASE}/keluhan`;
  return axios.get(url, { params: { BantuanId: BantuanId || undefined } });
};

export default {
  getBantuan,
  getBantuanById,
  getBantuanRekap,
  updateBantuan,
  deleteBantuan,
  getBantuanGaps,
  syncBantuanGaps,
  createBantuanLengkap,
  createBantuanManual,
  getTflList,
  getAgrList,
  assignTflToBantuan,
  updatePenerimaByTfl,
  upsertRab,
  getRabByBantuan,
  getRabForSupplier,
  getAllRab,
  getRabForTfl,
  getProgressKeuangan,
  updateProgressKeuangan,
  deleteProgressDokumen,
  deleteProgressFoto,
  initProgressFisikPembangunan,
  initProgressFisikRehabilitasi,
  getProgressFisik,
  updateProgressFisikLangkah,
  deleteProgressFisikFoto,
  addRehabilitasiLangkah,
  deleteProgressFisikLangkah,
  initProgressAdministrasi,
  getProgressAdministrasi,
  updateProgressAdministrasi,
  deleteProgressAdministrasiDokumen,
  deleteProgressAdministrasiFoto,
  upsertAdmBantuan,
  getAdmBantuan,
  deleteAdmDokumen,
  deleteAdmFoto,
  createProsesBantuan,
  updateStatusProses,
  getDashboardStats,
  getAllMonitoring,
  getMonitoringDetail,
  addLangkah,
  updateLangkahStatus,
  deleteLangkah,
  getPresentase,
  addLog,
  getLogsByBantuan,
  addKeluhan,
  getKeluhan,
};